/**
 * Hook to access authentication state from router context
 */

import { useRouteContext } from "@tanstack/react-router"
import type { AuthState } from "./types"

/**
 * Get authentication state from router context
 * @throws Error if used outside router context
 */
export function useAuth(): AuthState {
	const context = useRouteContext({ from: "__root__" })
	const auth = context.auth

	if (!auth) {
		throw new Error("useAuth must be used within RouterProvider")
	}

	return auth
}
